import React, { FC, useEffect, useState, useRef } from "react";
import PortalRegistrationCghs from "../../../../components/patient/Portal Registration/PortalRegistrationCghs";
import { Form, Modal, Row, Col, Tag, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import dayjs from "dayjs";
import PortalSubmissionModal from "../../../../components/patient/PreAuth/PortalSubmissionModal";
import ManuallyIdModal from "../../../../components/patient/PreAuth/ManuallyIdModal";
import PortalSubmitModal from "../../../../components/patient/PreAuth/PortalSubmitModal";
import {
  fetchStepperData,
  getPortalDataCghsNew,
  getVisitStageStates,
} from "../../../../models/preAuthSlice";
import {
  getRegisterValidation,
  otpVerify,
  register,
  registerPatientPortalCghsNew,
  registerValidation,
  submitIdCghsNew,
  updateRegistrationValidationDetails,
} from "../../../../apis/SchemeService/CGHS/cghsService";
import {
  getBasicDetails,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import RightSidePreviewWindow from "../../../../components/modals/PreviewModalForDrawer";
import { getAllStarhealthDocumentsData } from "../../../../apis/patientService";
import Loader from "../../../../utils/Spinners";
import ManuallyRegistrationIdPortal from "../../../../components/patient/PreAuth/ManuallyRegistrationIdPortal";
import PortalRegistrationCghsNew from "../../../../components/patient/Portal Registration/PortalRegistrationCghsNew";
import RegistrationValidationModal from "../../../../components/patient/Portal Registration/RegistrationValidationModal";
import { errorMessageModal } from "../../../../utils/modalMessage";

type PortalRegistrationNewCghsContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

const PortalRegistrationNewCghsContainer: FC<
  PortalRegistrationNewCghsContainerProps
> = ({ activeKey, sseData, sseUpdateCount }) => {
  const [form] = Form.useForm();
  const [otpVerificationForm] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuth, cases } = useSelector((state: RootState) => state);
  const [editRegId, setEditRegId] = useState<boolean>(false);
  const [isSubmittedOnPortal, setIsSubmittedOnPortal] =
    useState<boolean>(false);
  const [isManuallyEnteredId, setIsManuallyEnteredId] = useState(false); //open enter id manually
  const [manuallyRegistrationIdPortal, setManuallyRegistrationIdPortal] =
    useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const [previewDocument, setPreviewDocument] = useState<boolean>(false);
  const [cardDocumentUrl, setCardDocumentUrl] = useState<any>("");
  const [isFetchingDocuments, setIsFetchingDocuments] =
    useState<boolean>(false);
  const [showRegistrationId, setShowRegistrationId] = useState<boolean>(false);
  const [registrationValidationStatus, setRegistrationValidationStatus] =
    useState<any>(null);
  const [isRegistraionValidatedModalOpen, setIsRegistraionValidatedModalOpen] =
    useState(false);
  const [validationRes, setValidationRes] = useState<any>(null);
  const [isValidationLoading, setIsValidationLoading] =
    useState<boolean>(false);
  const [showVerifyButton, setShowVerifyButton] = useState<boolean>(true);
  const [isMobileNumberVerified, setIsMobileNumberVerified] =
    useState<boolean>(false);
  const [isOTPVerified, setIsOTPVerified] = useState<boolean>(false);
  const [isOTPVerificationLoading, setIsOTPVerificationLoading] =
    useState<boolean>(false);
  const [isRegisterLoading, setIsRegisterLoading] = useState<boolean>(false);
  const [isPortalRegistrationSuccess, setIsPortalRegistrationSuccess] =
    useState<boolean>(false);
  const [openRegistrationForm, setOpenRegistrationForm] =
    useState<boolean>(false);
  const [isErrorState, setIsErrorState] = useState<boolean>(false);
  const lastErrorMessageRef = useRef<string | null>(null);

  useEffect(() => {
    if (isPortalRegistrationTabActive()) {
      lastErrorMessageRef.current = null;
    }
  }, [activeKey]);

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0])),
  );

  const fetchStepperForStatus = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const isPortalRegistrationTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId,
    );

    setIsErrorState(currentStage?.state?.toLowerCase() === "error");

    return (
      currentStage?.visitStage?.toUpperCase() ===
      "Portal registration"?.toUpperCase()
    );
  };

  useEffect(() => {
    setRegistrationValidationStatus(
      preAuth?.portalData?.portalRegistrationStatus,
    );
  }, [preAuth?.portalData]);

  useEffect(() => {
    if (patients) {
      form.setFieldsValue({
        beneficiaryId:
          preAuth?.portalData?.beneficiaryId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId ||
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.beneficiaryId ||
          patients?.fetchBasicDetails?.visitInfoResponse?.opNumber,
        registrationDate: preAuth?.portalData?.registrationDate
          ? dayjs(preAuth?.portalData?.registrationDate, dateFormat)
          : patients?.fetchBasicDetails?.visitInfoResponse?.doa
            ? dayjs(
                patients?.fetchBasicDetails?.visitInfoResponse?.doa,
                dateFormat,
              )
            : null,
        registrationId: preAuth?.portalData?.schemeRegistrationId,
      });
    }
  }, [patients?.fetchBasicDetails, preAuth?.portalData]);

  useEffect(() => {
    if (
      isErrorState &&
      preAuth?.portalData?.claimIdGenerationErrorMessage &&
      preAuth?.portalData?.claimIdGenerationErrorMessage !==
        lastErrorMessageRef.current &&
      isPortalRegistrationTabActive()
    ) {
      errorMessageModal(preAuth?.portalData?.claimIdGenerationErrorMessage);
      lastErrorMessageRef.current =
        preAuth?.portalData?.claimIdGenerationErrorMessage;
    }
  }, [preAuth?.portalData, isErrorState, activeKey]);

  const fetchPortalData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      const resp = await dispatch(
        getPortalDataCghsNew({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );

      if (getPortalDataCghsNew.rejected.match(resp)) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  const fetchVisitStageIds = async () => {
    if (currentActiveStage?.visitStageId) {
      const resp = await dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId }),
      );

      if (getVisitStageStates.rejected.match(resp)) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPortalRegistrationTabActive()) {
      fetchPortalData();
      fetchVisitStageIds();
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    currentActiveStage?.visitStageId,
    activeKey,
  ]);

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );
    }
    await fetchPortalData();
    fetchStepperForStatus();
    await getTimelineDetail();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPortalRegistrationTabActive()) {
      // fetchStepperForStatus();
      // getTimelineDetail();
      fetchDocuments();
    }
  }, [
    preAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (
  //       patients?.fetchBasicDetails?.casesResponse?.id &&
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id
  //     ) {
  //       if (
  //         preAuth?.portalData?.schemeRegistrationId == null &&
  //         preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
  //           "portal registration" &&
  //         preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
  //           "initiated"
  //       ) {
  //         fetchPortalData();
  //       }
  //     }
  //   }, 10000);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.id,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //   preAuth?.portalData,
  // ]);

  const handleGetRegistrationValidation = async () => {
    try {
      const res = await getRegisterValidation(
        preAuth?.portalData?.schemeRegistrationId,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
      );
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    }
  };

  const handleRegistrationValidation = async () => {
    try {
      const payload = {
        registrationId: preAuth?.portalData?.schemeRegistrationId,
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      };
      setIsValidationLoading(true);
      if (registrationValidationStatus?.toUpperCase() === "VALIDATED") {
        setIsValidationLoading(true);

        try {
          // const validationRes = await getRegisterValidation(
          //   preAuth?.portalData?.schemeRegistrationId,
          //   patients?.fetchBasicDetails?.visitInfoResponse?.id
          // );

          const validationRes = await registerValidation(payload);

          setValidationRes(validationRes);

          const status =
            validationRes?.status ||
            validationRes?.data?.status ||
            validationRes?.validationStatus;

          if (
            status?.toLowerCase() === "validated" ||
            status?.toLowerCase() === "completed" ||
            status?.toLowerCase() === "failed"
          ) {
            successMessage("Registration validation completed!");
            if (
              status?.toLowerCase() === "validated" &&
              validationRes?.discrepancyStatus
            ) {
              setRegistrationValidationStatus("Discrepancy");
            } else setRegistrationValidationStatus(status);

            // if (
            //   status?.toLowerCase() === "validated" &&
            //   validationRes?.discrepancyStatus
            // ) {
            setIsRegistraionValidatedModalOpen(true);
            // }

            setIsValidationLoading(false);
            return;
          }

          // mirrors original timeout behavior
          errorMessage("Request timeout.");
          setIsValidationLoading(false);
          setRegistrationValidationStatus("Failed");
        } catch (err) {
          console.error("Error while polling validation:", err);
          setIsValidationLoading(false);
          errorMessage("An error occurred while checking validation.");
        }

        return;
      }

      const res = await registerValidation(payload);

      setValidationRes(res);

      const status = res?.status || res?.data?.status || res?.validationStatus;

      if (
        status?.toLowerCase() === "validated" ||
        status?.toLowerCase() === "completed" ||
        status?.toLowerCase() === "failed"
      ) {
        successMessage("Registration validation completed!");
        // clearInterval(intervalId);
        if (status?.toLowerCase() === "validated" && res?.discrepancyStatus) {
          setRegistrationValidationStatus("Discrepancy");
        } else setRegistrationValidationStatus(status);

        // if (status?.toLowerCase() === "validated" && res?.discrepancyStatus) {
        setIsRegistraionValidatedModalOpen(true);
        // }
        setIsValidationLoading(false);
        return;
      }

      // if (res) {
      //   let pollCount = 0;
      //   const maxPolls = 5; // total 10s if interval = 2s
      //   const interval = 2000; // 2 seconds
      //   const startTime = Date.now();

      //   const pollValidation = async () => {
      //     pollCount++;
      //     try {
      //       const validationRes = await getRegisterValidation(
      //         preAuth?.portalData?.schemeRegistrationId,
      //         patients?.fetchBasicDetails?.visitInfoResponse?.id
      //       );

      //       const status =
      //         validationRes?.status ||
      //         validationRes?.data?.status ||
      //         validationRes?.validationStatus;

      //       if (
      //         status?.toLowerCase() === "validated" ||
      //         status?.toLowerCase() === "completed" || status?.toLowerCase() === "failed"
      //       ) {
      //         successMessage("Registration Validation Completed!");
      //         clearInterval(intervalId);
      //         clearTimeout(timeoutId);
      //         setRegistrationValidationStatus(status);
      //       } else if (pollCount >= maxPolls) {
      //         clearInterval(intervalId);
      //         clearTimeout(timeoutId);
      //         errorMessage("Request timeout.");
      //         setRegistrationValidationStatus("Failed");
      //       }
      //     } catch (err) {
      //       console.error("Error checking validation:", err);
      //     }
      //   };

      //   const intervalId = setInterval(pollValidation, interval);

      //   const timeoutId = setTimeout(() => {
      //     clearInterval(intervalId);
      //     errorMessage("Request timeout.");
      //     setRegistrationValidationStatus("Failed");
      //   }, 10000);
      // }

      //new one
      // if (res) {
      //   let pollCount = 0;
      //   const pollInterval = 5000;
      //   const maxPolls = (60 * 1000) / pollInterval;

      //   try {
      //       const validationRes = await getRegisterValidation(
      //         preAuth?.portalData?.schemeRegistrationId,
      //         patients?.fetchBasicDetails?.visitInfoResponse?.id
      //       );

      //       setValidationRes(validationRes);

      //       const status =
      //         validationRes?.status ||
      //         validationRes?.data?.status ||
      //         validationRes?.validationStatus;

      //       if (
      //         status?.toLowerCase() === "validated" ||
      //         status?.toLowerCase() === "completed" ||
      //         status?.toLowerCase() === "failed"
      //       ) {
      //         successMessage("Registration validation completed!");
      //         // clearInterval(intervalId);
      //         if (
      //           status?.toLowerCase() === "validated" &&
      //           validationRes?.discrepancyStatus
      //         ) {
      //           setRegistrationValidationStatus("Discrepancy");
      //         } else setRegistrationValidationStatus(status);

      //         if (status?.toLowerCase() === "validated" && validationRes?.discrepancyStatus) {
      //           setIsRegistraionValidatedModalOpen(true);
      //         }
      //         setIsValidationLoading(false);
      //         return;
      //       }
      //       // else if (pollCount >= maxPolls) {
      //       //   errorMessage("Request timeout.");
      //       //   setIsValidationLoading(false);
      //       //   setRegistrationValidationStatus("Failed");
      //       // }
      //     } catch (err) {
      //       console.error("Error while polling validation:", err);
      //       setIsValidationLoading(false);
      //       errorMessage("An error occurred while checking validation.");
      //     }

      //   // const intervalId = setInterval(async () => {
      //   //   pollCount++;

      //   //   try {
      //   //     const validationRes = await getRegisterValidation(
      //   //       preAuth?.portalData?.schemeRegistrationId,
      //   //       patients?.fetchBasicDetails?.visitInfoResponse?.id
      //   //     );

      //   //     setValidationRes(validationRes);

      //   //     const status =
      //   //       validationRes?.status ||
      //   //       validationRes?.data?.status ||
      //   //       validationRes?.validationStatus;

      //   //     if (
      //   //       status?.toLowerCase() === "validated" ||
      //   //       status?.toLowerCase() === "completed" ||
      //   //       status?.toLowerCase() === "failed"
      //   //     ) {
      //   //       successMessage("Registration validation completed!");
      //   //       clearInterval(intervalId);
      //   //       if (
      //   //         status?.toLowerCase() === "validated" &&
      //   //         validationRes?.discrepancyStatus
      //   //       ) {
      //   //         setRegistrationValidationStatus("Discrepancy");
      //   //       } else setRegistrationValidationStatus(status);

      //   //       if (status?.toLowerCase() === "validated" && validationRes?.discrepancyStatus) {
      //   //         setIsRegistraionValidatedModalOpen(true);
      //   //       }
      //   //       setIsValidationLoading(false);
      //   //       return;
      //   //     } else if (pollCount >= maxPolls) {
      //   //       errorMessage("Request timeout.");
      //   //       setIsValidationLoading(false);
      //   //       clearInterval(intervalId);
      //   //       setRegistrationValidationStatus("Failed");
      //   //     }
      //   //   } catch (err) {
      //   //     console.error("Error while polling validation:", err);
      //   //     setIsValidationLoading(false);
      //   //     clearInterval(intervalId);
      //   //     errorMessage("An error occurred while checking validation.");
      //   //   }
      //   // }, pollInterval);

      //   // setTimeout(() => clearInterval(intervalId), 60 * 1000);
      // }
    } catch (err) {
      setIsValidationLoading(false);
      errorMessage("Please, Try again after sometime");
    }
  };

  useEffect(() => {
    if (
      preAuth?.portalData?.schemeRegistrationId &&
      !preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted &&
      !preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.initiated &&
      preAuth?.portalData?.portalRegistrationStatus?.toUpperCase() !==
        "VALIDATED" &&
      preAuth?.portalData?.portalRegistrationStatus?.toUpperCase() !==
        "COMPLETED"
      // && isPortalRegistrationTabActive()
    ) {
      // handleRegistrationValidation();
      setShowVerifyButton(true);
    }
  }, [preAuth?.portalData]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    let pollCount = 0;
    const maxPolls = 24;
    const modifiedAt = preAuth?.portalData?.modifiedAt;

    const modifiedTime = new Date(modifiedAt).getTime();
    const now = Date.now();
    const diffSeconds = (now - modifiedTime) / 1000;

    if (
      preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
        "portal registration" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "initiated" &&
      !preAuth?.portalData?.schemeRegistrationId &&
      diffSeconds <= 78
    ) {
      intervalId = setInterval(() => {
        pollCount++;
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          fetchPortalData();
        }

        if (preAuth?.portalData?.schemeRegistrationId) {
          if (intervalId) clearInterval(intervalId);
          if (timeoutId) clearTimeout(timeoutId);
        }

        if (pollCount >= maxPolls) {
          if (intervalId) clearInterval(intervalId);
          setShowRegistrationId(true);
          // form.setFieldValue("registrationId", "-");
        }
      }, 5000);

      timeoutId = setTimeout(() => {
        if (intervalId) clearInterval(intervalId);
        setShowRegistrationId(true);
        // form.setFieldValue("registrationId", "-");
      }, 120000);
    } else if (
      preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
        "portal registration" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "initiated" &&
      !preAuth?.portalData?.schemeRegistrationId &&
      diffSeconds > 78
    ) {
      setShowRegistrationId(true);
    } else if (
      preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
        "portal registration" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "manually submitted" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "id generated" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.includes("verified") &&
      !preAuth?.portalData?.schemeRegistrationId
    ) {
      setShowRegistrationId(true);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    preAuth?.portalData?.modifiedAt,
    preAuth?.portalData?.schemeRegistrationId,
    preAuth?.portalData?.stateName,
    preAuth?.portalData?.visitStagesName,
  ]);

  const handleEditRegId = React.useCallback(() => {
    setEditRegId(!editRegId);
  }, [editRegId]);

  const handleManuallyIdEnter = React.useCallback(() => {
    setIsSubmittedOnPortal(false);
    setIsManuallyEnteredId(true);
  }, []);

  const handleCancelPortal = React.useCallback((isNoClicked?: boolean) => {
    setIsSubmittedOnPortal(false);
    // setOpen(true);
    if (isNoClicked) {
      setOpenRegistrationForm(true);
    }
  }, []);

  const handleCancelManuallyId = React.useCallback(() => {
    setIsManuallyEnteredId(false);
  }, []);

  const handleOk = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleRegistrationCancel = () => {
    setOpen(false);
    setIsSubmittedOnPortal(false);
  };

  const handleRegistration = React.useCallback(() => {
    if (patients?.fetchBasicDetails?.casesResponse.integratedWithPortal) {
      setIsSubmittedOnPortal(true);
    } else {
      setManuallyRegistrationIdPortal(true);
    }
  }, []);

  const handleSaveManually = async (values: any) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const registrationFormValues = await form.validateFields();
        const updatedData = {
          ...registrationFormValues,
          registrationDate: registrationFormValues?.registrationDate
            ? dayjs(registrationFormValues?.registrationDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          manualRegistration: true,
          schemeRegistrationId: values?.manualId,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          isCghs:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CGHS NEW"
              ? true
              : false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        setIsLoading(true);
        await registerPatientPortalCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          updatedData,
        );
        successMessage("Registered Successfully");
        setIsLoading(false);
        setManuallyRegistrationIdPortal(false);
        await fetchPortalData();
        fetchStepperForStatus();
        await getTimelineDetail();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please, Fill All details before submitting");
      } else {
        errorMessageModal(err?.message || "Please, Try again later");
      }
      setIsLoading(false);
    }

    setIsManuallyEnteredId(false);
    setManuallyRegistrationIdPortal(false);
  };

  const handleSaveModalOption = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const registrationFormValues = await form.validateFields();
        const updatedData = {
          ...registrationFormValues,
          registrationDate: registrationFormValues?.registrationDate
            ? dayjs(registrationFormValues?.registrationDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          isCghs:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CGHS NEW"
              ? true
              : false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        setIsLoading(true);
        await registerPatientPortalCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          updatedData,
        );
        successMessage("Registered Successfully");
        setIsLoading(false);
        await fetchPortalData();
        await getTimelineDetail();
        await fetchStepperForStatus();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please, Fill All details before submitting");
      } else {
        errorMessageModal(err?.message || "Please, Try again later");
      }
      setIsLoading(false);
    }
    setOpen(false);
  };

  const fetchDocuments = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      if (isFetchingDocuments) return;
      try {
        setIsFetchingDocuments(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        );
        const cardUrl = AllDocumentList?.["PreAuth"]?.find(
          (document: any) => document.label?.toUpperCase() === "CGHS CARD",
        );
        setCardDocumentUrl(cardUrl?.documentList?.[0]?.documentUrl);
        setIsFetchingDocuments(false);
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setIsFetchingDocuments(false);
      }
    }
  };

  const handleSubmitId = async (values: any) => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
      ) {
        const formData = {
          registrationId: values.registrationId,
          claimId: null,
        };
        const submitData = await submitIdCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          formData,
        );
        if (submitData) {
          if (editRegId) {
            successMessage("Registration Id updated successfully");
          } else {
            successMessage(
              "Registration is Successful, Please Proceed further",
            );
          }
          setEditRegId(false);
          setRegistrationValidationStatus(null);
          await fetchPortalData();
          fetchStepperForStatus();
        }
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handlePreviewDocument = React.useCallback(() => {
    setPreviewDocument(true);
  }, []);

  const handleUpdateRegistrationValidation = async (data: any) => {
    try {
      const res = await updateRegistrationValidationDetails(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        data,
      );
      successMessage("Details Updated Successfully");
      // setIsRegistraionValidatedModalOpen(false);
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
      fetchPortalData();
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  const handleMobileVerification = async () => {
    try {
      const otpVerificationFormValues =
        await otpVerificationForm.validateFields();
      const requestPayload = {
        mobileNumber: otpVerificationFormValues.mobile,
        otp: "",
        otpProvided: false,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      };

      await otpVerify(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        requestPayload,
      );

      setIsMobileNumberVerified(true);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsMobileNumberVerified(false);
    }
  };

  const handleOTPVerification = async () => {
    setIsOTPVerificationLoading(true);
    try {
      const otpVerificationFormValues =
        await otpVerificationForm.validateFields();

      const requestPayload = {
        mobileNumber: otpVerificationFormValues.mobile,
        otp: otpVerificationFormValues.otp,
        otpProvided: true,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      };

      await otpVerify(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        requestPayload,
      );
      setIsOTPVerified(true);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsOTPVerified(false);
    } finally {
      setIsOTPVerificationLoading(false);
    }
  };

  const handleRegister = async () => {
    setIsRegisterLoading(true);
    try {
      // const registrationFormValues = await form.validateFields();
      // const otpVerificationFormValues =
      // await otpVerificationForm.validateFields();

      const registrationFormValues = form.getFieldsValue();
      const otpVerificationFormValues = otpVerificationForm.getFieldsValue();

      const requestPayload = {
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        communicationAddress: {
          sameAsCardAddress: true,
          pincode: registrationFormValues?.pincode,
          city: registrationFormValues?.city,
        },
        patientAttendantDetails: {
          attendantType: registrationFormValues?.attendantType,
          fullName:
            registrationFormValues?.attendantType === "self"
              ? patients?.fetchBasicDetails?.patientResponse?.fullName
              : registrationFormValues?.fullName,
          relationship: registrationFormValues?.relationship,
          otherRelation: registrationFormValues?.otherRelationship,
          mobileNumber:
            registrationFormValues?.attendantType === "self"
              ? otpVerificationFormValues?.mobile
              : patients?.fetchBasicDetails?.patientResponse?.primaryMobile,
          otp: otpVerificationFormValues?.otp,
          otpProvided: true,
          beneficiaryOwnedMobile: true,
        },
      };

      await register(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        requestPayload,
      );
      setIsPortalRegistrationSuccess(true);
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsPortalRegistrationSuccess(false);
    } finally {
      setIsRegisterLoading(false);
    }
  };

  return (
    <>
      {isFetchingDocuments ? (
        <Loader />
      ) : (
        <PortalRegistrationCghsNew
          editRegId={editRegId}
          handleEditRegId={handleEditRegId}
          handleSubmitId={handleSubmitId}
          handleRegistration={handleRegistration}
          form={form}
          portalData={preAuth?.portalData}
          handlePreviewDocument={handlePreviewDocument}
          cardDocumentUrl={cardDocumentUrl}
          showRegistrationId={showRegistrationId}
          registrationValidationStatus={registrationValidationStatus}
          isValidationLoading={isValidationLoading}
          showVerifyButton={showVerifyButton}
          handleRegistrationValidation={handleRegistrationValidation}
          handleOTPVerification={handleOTPVerification}
          handleMobileVerification={handleMobileVerification}
          otpVerificationForm={otpVerificationForm}
          isMobileNumberVerified={isMobileNumberVerified}
          isOTPVerified={isOTPVerified}
          isOTPVerificationLoading={isOTPVerificationLoading}
          handleRegister={handleRegister}
          isRegisterLoading={isRegisterLoading}
          openRegistrationForm={openRegistrationForm}
          isPortalRegistrationSuccess={isPortalRegistrationSuccess}
          patientResponse={patients?.fetchBasicDetails?.patientResponse}
        />
      )}

      <PortalSubmissionModal
        open={isSubmittedOnPortal}
        title={"Do you have Registration Id?"}
        handleCancel={(isNoClicked?: boolean) =>
          handleCancelPortal(isNoClicked)
        }
        handleSave={handleManuallyIdEnter}
      />
      <ManuallyIdModal
        open={isManuallyEnteredId}
        title={"Enter Registration Id"}
        handleCancel={handleCancelManuallyId}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />
      <PortalSubmitModal
        open={open}
        title={"Do You want to Register PreAuth?"}
        handleOk={handleOk}
        handleCancel={handleRegistrationCancel}
        handleSave={handleSaveModalOption}
        isLoading={isLoading}
      />

      <RightSidePreviewWindow
        key={cardDocumentUrl}
        documentUrl={cardDocumentUrl}
        handleCancel={() => setPreviewDocument(false)}
        open={previewDocument}
        setOpen={setOpen}
        // wrapperRef={wrapperRef}
      />

      <ManuallyRegistrationIdPortal
        open={manuallyRegistrationIdPortal}
        title={"Enter Registration Id"}
        handleCancel={() => setManuallyRegistrationIdPortal(false)}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />

      <RegistrationValidationModal
        open={isRegistraionValidatedModalOpen}
        onCancel={() => setIsRegistraionValidatedModalOpen(false)}
        validationRes={validationRes}
        onUpdate={handleUpdateRegistrationValidation}
        totalCases={cases?.caseType || []}
      />
    </>
  );
};

export default PortalRegistrationNewCghsContainer;
